'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _app = require('../actions/app');

var INITIAL_STATE = {
	canScrollToTop: false,
	headerHeight: null
};

var app = function app(state, action) {
	switch (action.type) {
		case _app.SET_CAN_SCROLL_TO_TOP:
			return Object.assign({}, state, { canScrollToTop: action.status });
		case _app.UPDATE_HEADER_SIZE:
			return Object.assign({}, state, { headerHeight: action.payload.headerHeight });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = app;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/app.js
// module id = 1686
// module chunks = 0